module.exports = __webpack_public_path__ + "media/images/christmas_veedelsretter-d42e38ad9872adccbcbf911c33a6e5c5.svg";